import { Box, Text, useClassNames } from '@factorialco/deprecated-design-system'
import { differenceInDays, isSameDay } from 'date-fns'
import moment from 'moment'

import i18n from 'modules/core/lib/i18n'

import { stylesRefs } from './index.styles'
import './index.styles.css'

interface IScheduleHeaderProps {
  range: [Date, Date]
}

const ScheduleHeader = ({ range }: IScheduleHeaderProps) => {
  const cx = useClassNames(stylesRefs)
  const startDate = range[0]
  const endDate = range[1]
  const daysDiff = differenceInDays(endDate, startDate)

  const selectedDates = Array.from({ length: daysDiff + 1 }, (_, i) => {
    const date = moment(startDate).add(i, 'days')
    return date.toDate()
  })

  const today = new Date()

  const isToday = (date: Date) => {
    return isSameDay(today, date)
  }

  return (
    <Box className={cx('scheduleHeaderSticky')}>
      <Box className={cx('scheduleHeader')}>
        <Box
          key="header-row"
          paddingX="s8"
          justifyContent="center"
          className={cx('scheduleHeaderCellSticky', 'scheduleHeaderBorder')}
        >
          <Text size="100" weight="semibold" color="grey1000" caps>
            {i18n.t('project_management.schedule.header.title_options.first_name')}
          </Text>
        </Box>
        {selectedDates.map((date, index) => {
          const isTodayDate = isToday(date)

          return (
            <Box
              className={cx('scheduleHeaderBorder')}
              background="white"
              key={index}
              paddingY="s8"
              paddingX="s8"
              flexDirection="row"
              minWidth="s64"
            >
              <Text
                size="100"
                weight={isTodayDate ? 'bold' : 'semibold'}
                color={isTodayDate ? 'grey1000' : 'grey700'}
                letterSpacing="s4"
                capitalize
              >
                {moment(date).format('ddd')[0]}
              </Text>
              <Text
                size="100"
                weight={isTodayDate ? 'bold' : 'semibold'}
                color={isTodayDate ? 'grey1000' : 'grey700'}
              >
                {moment(date).format('DD')}
              </Text>
            </Box>
          )
        })}
      </Box>
    </Box>
  )
}

export default ScheduleHeader
